export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11177.8f6d88b6.jpg";